import Logger from '../logger';
import event from '../mixins/event';
import Player from '@vimeo/player';

class VideoAndText {

	// Vars
	// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

	/**
	 * Class constructor
	 */
	constructor(dom) {

		this.NAME = 'VideoAndText';

		this.dom = dom;

		this.player = null;
		this.playerDom = this.dom.querySelector(`[data-video-and-text-video]`);
		this.vimeoId = this.playerDom?.dataset.videoAndTextVideo;
		this.videoFileDom = this.dom.querySelector(`[data-video-and-text-video-file]`);
		this.placeholderDom = this.dom.querySelector(`[data-video-and-text-placeholder]`);

		this.modalDom = this.dom.querySelector(`[data-video-and-text-modal]`);
		this.modalActiveClass = `video-and-text__video-modal--active`;

		this.closeButtonDom = this.dom.querySelector(`[data-video-and-text-modal-close]`);
	}

	/**
	 * init - Initialize the form
	 */
	init() {
		Logger.info(`${this.NAME} > init`);
		this.initModal();
		this.initPlaceholder();
	}

	/**
	 * initModal - Initialize the modal
	 */
	initModal() {
		Logger.info(`${this.NAME} > initModal`);

		this.modalDom?.addEventListener(`click`, this.hideModal.bind(this));
		this.closeButtonDom?.addEventListener(`click`, this.hideModal.bind(this));
	}

	/**
	 * initPlayer - Initialize the the player
	 */
	initPlayer() {
		Logger.info(`${this.NAME} > initPlayer`);

		if (this.vimeoId) {
			if (this.player) return;

			this.player = new Player(this.playerDom, {
				id: this.vimeoId,
				autoplay: true,
			});
		} else if (this.videoFileDom) {
			this.videoFileDom.play();
		}
	}

	/**
	 * initPlaceholder - Initialize the placeholder
	 */
	initPlaceholder() {
		Logger.info(`${this.NAME} > initPlaceholder`);

		if (!this.placeholderDom) return;

		this.placeholderDom.addEventListener(`click`, this.showModal.bind(this));

	}

	/**
	 * hideModal - Hide the modal
	 */
	hideModal() {
		Logger.info(`${this.NAME} > hideModal`);

		this.player?.pause();
		this.videoFileDom?.pause();
		this.modalDom.classList.remove(this.modalActiveClass);
	}

	/**
	 * showModal - Show the modal
	 */
	showModal() {
		Logger.info(`${this.NAME} > showModal`);

		this.initPlayer();

		this.modalDom.classList.add(this.modalActiveClass);
	}

}

Object.assign(VideoAndText.prototype, event);

export default VideoAndText;
